// extracted by mini-css-extract-plugin
module.exports = {"skills":"skills_skills__1_vFZ","subheading":"skills_subheading__TgoIU","skill_rack":"skills_skill_rack__3nSej"};